import { combineReducers } from "redux";
import {
    historicalSnapshotsReducer,
    IHistoricalSnapshotState,
} from "./historical-snapshots/historical-snapshots.reducer";
import {
    listDetailsReducer,
    IListDetailsState,
} from "./list-details/list-page.reducer";
import { ISublistState, sublistReducer } from "./sublists/sublists.reducer";

export const listPageReducer = combineReducers({
    listDetails: listDetailsReducer,
    historicalSnapshot: historicalSnapshotsReducer,
    sublist: sublistReducer,
});

export interface IListPageState {
    listDetails: IListDetailsState;
    historicalSnapshot: IHistoricalSnapshotState;
    sublist: ISublistState;
}
